export default __webpack_public_path__ + "static/media/product-image-24.23f778b7.jpg";